import { Injectable } from '@angular/core';
import { DialogRef, DialogResult, DialogService } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HtmlPaneComponent } from '../components';

@Injectable({
  providedIn: 'root'
})

export class ConfirmationDialogHtmlPaneService {

  constructor(private dialogService: DialogService) { }

  open(title: string, content: string, height: number): Observable<DialogResult> {

    const dialog: DialogRef = this.dialogService.open({
      title: title
      , content: HtmlPaneComponent
      , actions: [{ text: 'Yes', value: true, themeColor: 'primary' }, { text: 'No', value: false }]
      , width: 450
      , height: height
      , minWidth: 250
      , cssClass: 'isg-dialog-editor'
    });

    const paneRef = dialog.content.instance as HtmlPaneComponent;
    paneRef.htmlText = content;

    return dialog.result.pipe(
      tap(result => {
        if (result !== undefined) {
          dialog.close(); // Close the dialog if a button is clicked
        }
      })
    );
  }
}
